import api from './api';
import type { Paginated, Route } from '../types/api';

export async function listRoutes() {
  const { data } = await api.get<Paginated<Route> | Route[]>('/routes/');
  return Array.isArray(data) ? data : data.results;
}

export async function getRoute(id: number) {
  const { data } = await api.get<Route>(`/routes/${id}/`);
  return data;
}

export async function createRoute(payload: Partial<Route>) {
  const { data } = await api.post<Route>('/routes/', payload);
  return data;
}

export async function updateRoute(id: number, payload: Partial<Route>) {
  const { data } = await api.patch<Route>(`/routes/${id}/`, payload);
  return data;
}

export async function deleteRoute(id: number) {
  await api.delete(`/routes/${id}/`);
}

export async function setRouteStops(
  id: number,
  stops: { stop_id: number; sequence: number; minutes_from_origin: number }[],
) {
  const { data } = await api.post<Route>(`/routes/${id}/set_stops/`, { stops });
  return data;
}

export async function setRouteFares(
  id: number,
  fares: { boarding_stop_id: number; alighting_stop_id: number; amount: string }[],
) {
  const { data } = await api.post<Route>(`/routes/${id}/set_fares/`, { fares });
  return data;
}
